import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import {
  AssetDto,
  GalleryDto,
  GalleryGroupAccessLevel,
  GalleryPublicAccessLevel,
  GalleryTenantAccessLevel,
  Section,
} from '@nusign/picflow-backend-types';
import { Subject, takeUntil } from 'rxjs';
import { AdvancedModeComponent } from '../../../gallery-shared/components/advanced-mode/advanced-mode.component';
import { ApprovalLimitInfoComponent } from '../../../gallery/components/approval-limit-info/approval-limit-info.component';
import { getFullPath } from '../../../lib/get-full-path';
import { GalleryAccessLevelService } from '../../../services/gallery-access-level.service';
import { ViewGalleryHeaderComponent } from '../../components/view-gallery-header/view-gallery-header.component';

@Component({
  selector: 'app-view-gallery-advanced-mode-page',
  templateUrl: './view-gallery-advanced-mode-page.component.html',
  styleUrls: ['./view-gallery-advanced-mode-page.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, AdvancedModeComponent, ViewGalleryHeaderComponent, ApprovalLimitInfoComponent],
})
export class ViewGalleryAdvancedModePageComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private check = inject(ChangeDetectorRef);
  accessLevelService = inject(GalleryAccessLevelService);
  gallery: GalleryDto;
  assets: AssetDto[];
  sections: Section[];
  onAssetPage: boolean;
  accessLevel: GalleryGroupAccessLevel | GalleryPublicAccessLevel | GalleryTenantAccessLevel;
  destroyed$ = new Subject<void>();

  constructor() {
    this.gallery = this.route.snapshot.parent.data.gallery;
    this.assets = this.route.snapshot.data.assets;
    this.sections = this.route.snapshot.data.sections;
  }

  ngOnInit() {
    this.route.parent.data.pipe(takeUntil(this.destroyed$)).subscribe(data => {
      this.gallery = data.gallery;
      this.check.detectChanges();
    });
    this.route.data.pipe(takeUntil(this.destroyed$)).subscribe(data => {
      this.assets = data.assets;
      this.sections = data.sections;
      this.check.detectChanges();
    });
    this.router.events.pipe(takeUntil(this.destroyed$)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.onRoutechange();
      }
    });

    this.onRoutechange();
  }

  async onRoutechange() {
    const path = getFullPath(this.route.snapshot);
    this.onAssetPage = path.pop() !== 'advanced';
    this.accessLevel = await this.accessLevelService.getAccessLevel(this.gallery);
    this.check.detectChanges();
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
